import SodMitigatingControls from './SodMitigatingControls';

export default SodMitigatingControls;
